import { render, staticRenderFns } from "./Ekran_final.vue?vue&type=template&id=41a60d83"
import script from "./Ekran_final.vue?vue&type=script&lang=js"
export * from "./Ekran_final.vue?vue&type=script&lang=js"
import style0 from "./Ekran_final.vue?vue&type=style&index=0&id=41a60d83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports